import { useRouter } from 'next/router'
import { useSelector, useDispatch } from 'react-redux'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'

import { recordArticleReserveClicked, genPathByNavData } from 'utils/api'
import { setNavigateInfo, setPreselectVender } from 'store/cache/cacheSlice'

const Controls = ({ article }) => {
  const router = useRouter()
  const dispatch = useDispatch()
  const onReserveClick = async () => {
    dispatch(setNavigateInfo({ id: article._id, type: 'Article' }))
    recordArticleReserveClicked(article._id)
    if (!!article?.navData?.page) {
      const { path, isExternalLink } = await genPathByNavData(article.navData)
      if (path) {
        if (isExternalLink) {
          window.open(path, '_blank')
        } else {
          if (/^\/service\//.test(path)) {
            dispatch(setPreselectVender(article.vender?._id || null))
          }
          router.push(path)
        }
      }
    } else {
      router.push('/')
    }
  }

  return (
    <Box mt={4} display="flex">
      {article?.isDisplayGotoReservation && (
        <Button
          id="book"
          className="action living_track_article_gobook"
          variant="contained"
          color="primary"
          onClick={onReserveClick}
          sx={{ whiteSpace: 'nowrap', position: 'static', marginRight: 2 }}
        >
          {article?.gotoReservationDefaultName || '前往預約'}
        </Button>
      )}
    </Box>
  )
}

export default Controls
